import React, { useState } from "react";
// import { useContext } from "react";
import "./Products.css";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { AiOutlineLike } from "react-icons/ai";
import MainService from "../../common/MainService";

export default function Products(props) {
  const {
    
    src,
    produtName,
    url,
    origin,
    productPrice,
    discount,
    count,
    qr,
    model_id,
    certificate,
    likecount,
    product,
    btn1text,
    btn2text,
    contentsubcategory,
    subcategory,
    price,
  } = props;
  // const dispatch = useDispatch();

  // const counter = useSelector(selectCount);
  // console.log(counter,"uuuuu")
  const [checkLike, setLike] = useState(likecount);
  // const { handleClick } = useContext(TestoContext);
  const handleClick = (product) => {
    // console.log("oooooooooooooooooo",product)
    MainService.productLikeCount(product)
      .then((res) => {
        setLike(checkLike + 1);
        // dispatch(increment())
      })
      .catch((err) => {
        console.log("rerere", err);
      });
  };


  return (
    <div className="product-main-container mb-md-5 mb-4 ">
      <Row>
        <Col md={6}>
          <div className="product-container">
            {src !== "null" ? (
              <img alt="Img" src={src} />
            ) : (
              <div className="product-container-img mb-3 mb-md-0" />
            )}

            {/* <div>
              <img src={image2}/>
              <img/>
            </div> */}
          </div>
        </Col>

        <Col md={6}>
          <h2>{subcategory ? contentsubcategory : model_id}</h2>

          <h4 className="d-inline-block mb-2">{produtName}</h4>
          {url === "null" ? (
            <p>
              Product Details: <span> Not Availaible</span>
            </p>
          ) : (
            <p>
              Product Details:
              <a target="_blank" rel="noreferrer"  href={url}>
                Info Link
              </a>
            </p>
          )}
          <p>
            Country of Origin: <span>{origin}</span>
          </p>
          {!price && (
            <>
              <p>
                MRP: <span className="priceSpan">{productPrice}</span>
              </p>
              <p>
                Discounted Price: <span>{discount}</span>
              </p>
            </>
          )}
          {certificate !== "null" ? (
            <p>
              Certificates:{" "}
              <span>
                <a href={certificate} target="_blank" rel="noreferrer" download>
                  Certificates
                </a>
              </span>
            </p>
          ) : (
            <p>
              Certificates: <span>Not Availaible</span>
            </p>
          )}
        { !price && <p>
            Count: <span>{count}</span>
          </p>}

          <p className="likeSection">
            <span>{checkLike} </span>
            <AiOutlineLike
              onClick={() => {
                handleClick(product);
              }}
            />
          </p>
          {qr !== "null" && (
            <img
              className="d-block mb-2"
              width="140"
              height="140"
              src={qr}
              alt="Img"
            />
          )}
          <a
            className="buy-now d-inline-block me-2  mb-2"
            target="_blank"
            rel="noreferrer" 
            href="https://siapischain-abn.gbrapp.com/"
          >
            {btn1text ? btn1text : "Buy Now"}
          </a>

          {btn2text && (
            <a
              className="buy-now d-inline-block"
              target="_blank"
              rel="noreferrer" 
              href="https://siapischain-abn.gbrapp.com/"
            >
              {btn2text}
            </a>
          )}
        </Col>
      </Row>
    </div>
  );
}
